import React, { useRef } from 'react'
import { IconDelete, IconEdit, IconVersion } from '../../../../../../shared/icon/icon'
import { Menu, MenuLink } from '../../../../../../shared/menu/menu'
import { BreadcrumbView } from '../../../../../../context/breadcrumb.context'
import { Form, FormSubmit, FormText, FormTextArea } from '../../../../../../shared/form/form'
import { CardFullHeightScrollY } from '../../../../../../shared/card/card-full-height-scroll-y'
import { useApiFormFileContent } from '../../../../../../api-new/state/storage'
import { FormJsonEditorStr } from '../../../../../../shared/form/form-control/form-json-editor-str'
import { StorageFileDetails } from '../../../../../../shared/transfer/storage-file-details'
import { TransferFileUploadAssetVersion } from '../../../../../../shared/transfer/components/transfer-file-upload-asset-version'
import { useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min'
import { useApiFormAsset } from '../../../../../../api-new/state/content'
import { useParamsInt } from '../../../../../../shared/hooks/location'
import { useAuditRecord } from '../../../../../../shared/audit/history/audit-record-context'

export const AssetEdit = () => {
  const { assetID } = useParamsInt()
  // this asset's History (its URL shape is shared with pages that show no record)
  useAuditRecord({ type: 'assets', id: assetID, children: true, role: { org: 'NODE' } })
  const { url } = useRouteMatch()

  const refDetails = useRef()

  const apiFormAsset = useApiFormAsset()

  const handlePath = () => apiFormAsset.get(assetID)

  const handleSubmit = data => apiFormAsset.put(data.id, data)

  const handleComplete = () => {
    apiFormAsset.get(assetID)
    refDetails.current.reload()
  }

  const HeaderMenu = () =>
    <Menu>
      <MenuLink Icon={IconVersion} text="versions" to={`${url}/version`} show />
      <MenuLink Icon={IconDelete} text="delete" to={`${url}/${assetID}/delete`} show />
    </Menu>

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconEdit} text={apiFormAsset.form.name} onPath={handlePath}>
        <CardFullHeightScrollY title={apiFormAsset.form.name} HeaderMenu={HeaderMenu}>
          <Form state={apiFormAsset.form} onSubmit={handleSubmit}>
            <FormText label="createdAt" name="createdAt" readOnly />
            <FormText label="updatedAt" name="updatedAt" readOnly />
            <FormText label="name" name="name" required autoFocus />
            <FormText label="key" name="key" readOnly />
            <FormText label="active version" name="version" readOnly />
            <FormText label="version count" name="versionCount" readOnly />
            <FormText label="length" name="length" readOnly />
            <FormTextArea label="notes" name="notes" />
            <FormJsonEditorStr label="metadata" name="metadata" />
            <FormSubmit text="update" />
          </Form>

          <StorageFileDetails ref={refDetails} useApiFormFile={useApiFormFileContent} id={assetID} />

          <TransferFileUploadAssetVersion asset={apiFormAsset.form} onComplete={handleComplete} />
        </CardFullHeightScrollY>
      </BreadcrumbView>
    </React.Fragment>
  )
}
